//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    value: {
      type: Boolean,
      default: false
    },
    priceList: {
      type: Object,
      default: null,
    },
    monthly: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    features () {
      return this.priceList.data.features
    }
  },
  methods: {
    featureValueForItem (item, featureId, isMonthly) {
      const planFeatures = Array.isArray(item.data.features)
        ? item.data.features
        : typeof item.data.features === 'object' && !!item.data.features
          ? item.data.features[isMonthly ? 'month' : 'year']
          : []

      const feature = planFeatures.find(({ id }) => id === featureId)

      return feature?.value
    },
    getPrice (item) {
      return item.prices.find(p => this.monthly ? p.period_unit === 'month' : p.period_unit === 'year')
    },
    featureDescriptionForItem (item, featureId, isMonthly) {
      const planFeatures = Array.isArray(item.data.features)
        ? item.data.features
        : typeof item.data.features === 'object' && !!item.data.features
          ? item.data.features[isMonthly ? 'month' : 'year']
          : []

      const feature = planFeatures.find(f => f.id === featureId)
      return feature?.description
    }
  }
}
